// import React from "react"
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { Link } from "react-router-dom";

import Pagination from '@mui/material/Pagination';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";


import { format } from 'date-fns';
import moment from "moment";
import Pillchip from "../../components/Pillchip";
import ThreeDotsMenu from "../../components/ThreeDotsMenu";


const LoanComponents = ({ loan}) => {

    //Pagination
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const { data: loanComponents } = useQuery({
        queryKey: ['loan-components', page],
        queryFn: async () => {
            const response = await authAxios.get(`/loans/loan-components/?loan_case=${loan.loan_case}&page=${page}`);
            setPageCount(response.data.page_count)
            return response.data.results
        },
    });

    const threeSubMenu = [
        // {
        //     id: 1,
        //     menu: "PDF",
        //     url: "/dashboard/invoicereport/",
        // }, 
        {
            id: 1,
            menu: "View",
            url: "/dashboard/transaction/",

        }, 
    ]; 

    return (
        <>
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>#</th>
                        <th>Type</th>
                        <th>Due Date</th>
                        <th>Amount Due</th>
                        <th>Paid</th>
                        <th>Balance</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                {loanComponents && loanComponents.map(loanComponent => (
                    <tbody key={loanComponent.id}>
                        <tr>
                            <td>{loanComponent.id}</td>
                            <td>{loanComponent.name}</td>
                            <td>{moment(loanComponent.due_date).format('DD-MM-YYYY')}</td>
                            <td>{Number(loanComponent.amount_due).toLocaleString('en-UK')}</td>
                            <td>{Number(loanComponent.amount_paid).toLocaleString('en-UK')}</td>
                            <td>{Number(loanComponent.balance).toLocaleString('en-UK')}</td>
                            <td><Pillchip label={loanComponent.status_name} /></td>
                            <td className='styled-table-menu'>
                                <ThreeDotsMenu data={loanComponent} threeSubMenu={threeSubMenu} />
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
            
        <Pagination 
            className="custom-mui-pagination"
            count={pagecount} 
            page={page} 
            onChange={handlePageChange} 
        />

        </>

    );
  };
  
export default LoanComponents;